import { CHANGE_SERVICE_PROJECT, CHANGE_TAB } from '../constant/ActionType';

let initialState = {
  postTest: {
    service_id: null,
    service_name: null,
    project_id: [],
    project_name: null
  },
  activeTab: ""
};

function posTestReducer(state = initialState, action) {

  switch (action.type) {
    case CHANGE_SERVICE_PROJECT:
      return {
        ...state,
        postTest: {
          ...action.payload
        }
      }
    case CHANGE_TAB:
      return {
        ...state,
        activeTab: action.payload
      }
      break;
    default:
      return state;
      break;
  }
};

export default posTestReducer;
